// pages/Contact.jsx
import React from "react";
import MKBox from "components/MKBox";
import ContactCTA from "components/Contact/ContactCTA";
import ContactForm from "components/Contact/ContactForm";
import ContactInfo from "components/Contact/ContactInfo";

export default function Contact() {
  return (
    <MKBox
      px={{ xs: 3, md: 10 }}
      py={12}
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: "linear-gradient(to right, #e0f7fa, #f1f8ff)",
        backdropFilter: "blur(8px)",
      }}
    >
      <ContactCTA />
      <ContactForm />
      <ContactInfo />
    </MKBox>
  );
}
